import {
  clearSearchedBpsListRoutine, fetchAuthUserAccessRequestsRoutine,
  getAccessRequestsRoutine,
  searchInAllBpsRoutine,
  searchEstatesToRequestRoutine,
  clearSearchedEstatesRoutine
} from 'features/AccessRequest/ducks/actions'
import { emptyRequestAccessState } from 'features/AccessRequest/ducks/state'

export default (state = emptyRequestAccessState, action) => {
  switch (action.type) {
    case searchInAllBpsRoutine.SUCCESS:
      return {
        ...state,
        bps: action.payload
      }
    case clearSearchedBpsListRoutine.SUCCESS:
      return {
        ...state,
        bps: []
      }
    case searchEstatesToRequestRoutine.SUCCESS:
      return {
        ...state,
        estateResults: action.payload
      }
    case clearSearchedEstatesRoutine.SUCCESS:
      return {
        ...state,
        estateResults: []
      }
    case getAccessRequestsRoutine.SUCCESS:
      return {
        ...state,
        requests: action.payload
      }
    case fetchAuthUserAccessRequestsRoutine.SUCCESS:
      return {
        ...state,
        pending: action.payload.pending,
        pendingEstates: action.payload.estates
      }
    default:
      return state
  }
}
